var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { mapGetters } from 'vuex';
import Component from 'vue-class-component';
import LeftTree from './component/LeftTree';
import CategoryTable from './component/CategoryTable';
import PriceSetting from './PriceSetting';
import CategoryService from '../../api/CategoryService';
import BasicArcheivesService from '../../api/BasicArcheivesService';
import GoodService from "../../api/GoodService";
import DistriDialog from './component/DistributionDialog.vue';
import CopyDialog from './component/CopySupperDialog.vue';
import { Loading } from 'element-ui';
import GlobalVue from "../../globalVue";
import { UrlHelper } from '../../helper/UrlWrapper';
import CommonService from "../../api/CommonService";
import ArticleList from "../../components/alert/ArticleList.vue";
import ImportData from "../../components/dataActions/ImportData.vue";
var PurchasePrice = (function (_super) {
    __extends(PurchasePrice, _super);
    function PurchasePrice() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tableHeight = document.documentElement.clientHeight - 245;
        _this.total = 0;
        _this.data = [];
        _this.selectRows = [];
        _this.treeData = [];
        _this.categoryData = [];
        _this.currentSupplier = {};
        _this.isEdit = false;
        _this.importSuccessNum = 0;
        _this.importFailnum = 0;
        _this.befordImport = true;
        _this.importting = false;
        _this.afterImport = false;
        _this.failDownLoadUrl = "";
        _this.responseSuccess = false;
        _this.responseFail = false;
        _this.errorMsg = "";
        _this.dialogTableVisible = false;
        _this.formData = {
            status: -1,
            saleStatus: -1,
            category: null
        };
        return _this;
    }
    PurchasePrice.prototype.mounted = function () {
        this.service = CategoryService.getInstance();
        this.commonService = CommonService.getInstance();
        this.basicArcheivesService = BasicArcheivesService.getInstance();
        this.goodService = GoodService.getInstance();
        this.getTreeCategoryData();
        this.getCategory();
    };
    PurchasePrice.prototype.updateData = function () {
        this.$emit('search');
    };
    PurchasePrice.prototype.priceSetting = function () {
        GlobalVue.$emit("addTab", {
            component: PriceSetting,
            title: '价格设置',
            showExist: true,
            name: 15004,
            cprops: {
                supplier_upper_id: this.currentSupplier.supplier_upper_id,
                goods_type_id: this.formData.category
            }
        });
    };
    PurchasePrice.prototype.distribution = function () {
        var _this = this;
        var instance = this.$dialog(DistriDialog, {
            data: {
                supplier_upper_id: this.currentSupplier.supplier_upper_id
            }
        }, {
            title: "分配货品",
            width: 1100,
            height: 500
        }).instance;
        instance.$on('save:ok', function (selectGoodsFormatIds) {
            var params = {
                supplier_upper_id: _this.currentSupplier.supplier_upper_id,
                goods_format_ids: (selectGoodsFormatIds || []).join(',')
            };
            var loadingInstance = Loading.service({ fullscreen: true });
            _this.basicArcheivesService.supplierupperSaveGoods(params).then(function (res) {
                if (res.data.success) {
                    _this.$message.success('分配成功');
                    _this.search();
                }
                else {
                    _this.$message.error(res.data.msg);
                }
                loadingInstance.close();
            }, function (err) {
                _this.$message.error(err.message);
                loadingInstance.close();
            }).catch(function (err) {
                _this.$message.error(err.message);
                loadingInstance.close();
            });
        });
    };
    PurchasePrice.prototype.cancelGoods = function () {
        var _this = this;
        if (!this.selectRows || !this.selectRows.length) {
            this.$message.error('请先选择货品！');
            return;
        }
        this.$confirm("\u60A8\u6B63\u5728\u89E3\u9664\u4F9B\u5E94\u5546\u548C\u6240\u9009\u8D27\u54C1\u5173\u7CFB\uFF0C\u8BF7\u786E\u8BA4\u662F\u5426\u7EE7\u7EED\uFF1F", '提示', {
            customClass: 'confirm',
            confirmButtonText: '确定',
            center: true,
        }).then(function (res) {
            if (res) {
                var loadingInstance_1 = Loading.service({ fullscreen: true });
                var goodsFormatIds = _this.selectRows.map(function (item) {
                    return item.goods_format_id;
                });
                var supplierUperGoodsIds = _this.selectRows.map(function (item) {
                    return item.supplier_upper_goods_id;
                });
                var params = {
                    supplier_upper_id: _this.currentSupplier.supplier_upper_id,
                    goods_format_ids: (goodsFormatIds || []).join(','),
                    supplier_upper_goods_ids: (supplierUperGoodsIds || []).join(','),
                };
                _this.basicArcheivesService.supplierupperGoodsDelete(params).then(function (res) {
                    if (res.data.success) {
                        if (res.data.code == 13) {
                            var instance = _this.$dialog(ArticleList, {
                                data: {
                                    resData: res.data,
                                    sureButtonText: '知道了'
                                }
                            }, {
                                title: "提示",
                                width: 450,
                                height: 350
                            }).instance;
                            instance.$on("addClient:ok", function (data) {
                            });
                        }
                        else {
                            _this.$message.success('取消分配成功');
                            _this.search();
                        }
                    }
                    else {
                        _this.$message.error(res.data.msg);
                    }
                    ;
                    loadingInstance_1.close();
                }, function (err) {
                    _this.$message.error(err.message);
                    loadingInstance_1.close();
                }).catch(function (err) {
                    _this.$message.error(err.message);
                    loadingInstance_1.close();
                });
            }
        }).catch(function () { });
    };
    PurchasePrice.prototype.exportData = function () {
        var _this = this;
        var orderIds = this.selectRows.map(function (item) { return item.supplier_upper_goods_id; });
        var url = "supplierclientapi/supplieruppergoodsprice/export?ids=" + orderIds.join(",") + "&supplier_upper_id=" + this.currentSupplier.supplier_upper_id;
        url = UrlHelper.addParam(url, "token", this.user.token);
        var params = {
            supplier_upper_id: this.currentSupplier.supplier_upper_id,
            keyword: this.formData.text,
            goods_type_id: this.formData.category,
            category_id: this.currentSupplier.category_id ? this.currentSupplier.category_id : -1,
        };
        for (var key in params) {
            params[key] = (params[key] === undefined || params[key] === null) ? '' : params[key];
            url = UrlHelper.addParam(url, key, params[key]);
        }
        this.commonService.exportCheck(url)
            .then(function (res) {
            location.href = url;
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
    };
    PurchasePrice.prototype.nodeClick = function (node) {
        if (node && node.category_id) {
            this.currentSupplier = node;
            var pagination = this.$refs.pagination;
            pagination.clear();
            this.search(pagination.getPage());
        }
    };
    PurchasePrice.prototype.getCategory = function () {
        var _this = this;
        this.goodService.getCategory().then(function (res) {
            if (res.data.success) {
                _this.categoryData = res.data.data;
            }
            else {
                _this.$message.error(res.data.msg);
            }
        }, function (err) {
            _this.$message.error(err.message || err.msg);
        }).catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    PurchasePrice.prototype.copy = function () {
        var _this = this;
        var instance = this.$dialog(CopyDialog, {
            data: {
                supplier: this.currentSupplier
            }
        }, {
            title: "复制供应商货品",
            width: 560,
            height: 400
        }).instance;
        instance.$on("copyConfig:ok", function (data) {
            _this.basicArcheivesService.supplierupperCopy(data).then(function (res) {
                if (res.data.success) {
                    _this.$message.success('复制成功');
                }
            }, function (err) {
                _this.$message.error(err.message);
            }).catch(function (err) {
                _this.$message.error(err.message);
            });
        });
    };
    PurchasePrice.prototype.normalizer = function (node) {
        return {
            id: node.goods_type_id,
            label: node.goods_type_name,
            children: node.children,
        };
    };
    PurchasePrice.prototype.getTreeCategoryData = function () {
        var _this = this;
        this.basicArcheivesService.getSupplierupperCategoryList({ is_all: 1 }).then(function (res) {
            res.data.data.map(function (item) {
                if (item.category_id || item.category_name) {
                    item.supplier_upper_id = item.category_id;
                    item.supplier_upper_name = item.category_name;
                }
                if (item.children && item.children.length > 0) {
                    item.children.map(function (child, index) {
                        child.parent_id = item.category_id;
                        child.parent_name = item.category_name;
                    });
                }
            });
            console.log('res.data.data', res.data.data);
            _this.search();
            _this.treeData = res.data.data;
        });
    };
    PurchasePrice.prototype.pageChange = function (pager) {
        this.search(pager);
    };
    PurchasePrice.prototype.search = function (pager) {
        var _this = this;
        pager = pager ? pager : this.$refs.pagination.getPage();
        var loadingInstance = Loading.service({ fullscreen: true });
        var params = Object.assign({}, pager, {
            supplier_upper_id: this.currentSupplier.supplier_upper_id ? this.currentSupplier.supplier_upper_id : -1,
            keyword: this.formData.text,
            goods_type_id: this.formData.category,
            category_id: this.currentSupplier.category_id ? this.currentSupplier.category_id : -1,
            sort_field: this.order ? this.order[0] : null,
            sort_type: this.order ? this.order[1] : null
        });
        console.log(1112, this.currentSupplier.category_id, params);
        this.basicArcheivesService.getGoodsPriceList(params).then(function (res) {
            if (res.data && res.data.success) {
                _this.data = (res.data.data || []).map(function (item) {
                    if (item.current) {
                        if (!!item.current.es_time) {
                            item.current.noEsTimeEdit = true;
                        }
                        if (!!item.current.ee_time) {
                            item.current.noEeTimeEdit = true;
                        }
                    }
                    return __assign({}, item, { isEdit: false });
                });
                _this.total = res.data.total;
            }
            loadingInstance.close();
        }, function (err) {
            _this.$message.error(err.message || err.msg);
            loadingInstance.close();
        }).catch(function (err) {
            _this.$message.error(err.message);
            loadingInstance.close();
        });
    };
    PurchasePrice.prototype.handleSearch = function () {
        var pagination = this.$refs.pagination;
        pagination.clear();
        this.search(pagination.getPage());
    };
    PurchasePrice.prototype.setSelectRows = function (rows) {
        this.selectRows = rows;
    };
    PurchasePrice.prototype.sortChange = function (order) {
        this.order = order;
        this.search();
    };
    PurchasePrice.prototype.cacelItem = function () {
        this.search();
    };
    PurchasePrice.prototype.saveItem = function (data, supplier_upper_id) {
        var _this = this;
        this.basicArcheivesService.setSupplierupperGoodsPrice({
            supplier_upper_id: this.currentSupplier.supplier_upper_id || supplier_upper_id,
            data: JSON.stringify(data)
        }).then(function (res) {
            if (res.data.success) {
                _this.$message.success('保存成功');
                _this.search();
            }
        }, function (err) {
            _this.$message.error(err.message || err.msg);
        }).catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    PurchasePrice.prototype.batchSaveItem = function (data) {
        var _this = this;
        this.basicArcheivesService.batchSetSupplierupperGoodsPrice({
            data: JSON.stringify(data)
        }).then(function (res) {
            if (res.data.success) {
                _this.$message.success('保存成功');
                _this.search();
            }
        }, function (err) {
            _this.$message.error(err.message || err.msg);
        }).catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    PurchasePrice.prototype.importData = function () {
        this.$refs.ImportData.showImportModal();
    };
    PurchasePrice = __decorate([
        Component({
            components: {
                'left-tree': LeftTree,
                'category-table': CategoryTable,
                ImportData: ImportData
            },
            computed: __assign({}, mapGetters({
                "user": "user"
            }))
        })
    ], PurchasePrice);
    return PurchasePrice;
}(Vue));
export default PurchasePrice;
